import React from "react";
import styled from "styled-components";

export interface IrregularGridProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    columns?: number;
    gap?: number;
    pattern?: number[];
    cols?: number;
    colGap?: number;
    rowGap?: number;
    rowSize?: string;
    breakpoints?: Array<{
        maxWidth: number;
        pattern?: number[];
        cols?: number;
        colGap?: number;
        rowGap?: number;
    }>;
}

const IrregularGridRoot = styled.div<IrregularGridProps>`
    display: grid;
    grid-template-columns: repeat(${({ cols, columns }) => cols || columns || 3}, 1fr);
    column-gap: ${({ colGap, gap }) => (colGap !== undefined ? `${colGap}px` : gap !== undefined ? `${gap}rem` : "1rem")};
    row-gap: ${({ rowGap, gap }) => (rowGap !== undefined ? `${rowGap}px` : gap !== undefined ? `${gap}rem` : "1rem")};
    grid-auto-rows: ${({ rowSize }) => rowSize || "auto"};

    ${({ breakpoints }) =>
        breakpoints?.map(
            (bp) => `
            @media (max-width: ${bp.maxWidth}px) {
                grid-template-columns: repeat(${bp.cols || 3}, 1fr);
                ${bp.colGap !== undefined ? `column-gap: ${bp.colGap}px;` : ""}
                ${bp.rowGap !== undefined ? `row-gap: ${bp.rowGap}px;` : ""}
            }
        `
        )}
`;

export const IrregularGrid: React.FC<IrregularGridProps> = ({ children, ...props }) => {
    return (
        <IrregularGridRoot {...props}>
            {children}
        </IrregularGridRoot>
    );
};

export default IrregularGrid;


